package ui.gameplay.networking

import org.ttt.autogenesis.network.*
import kotlinx.serialization.builtins.*

internal fun registerActionHistoryClientHandlersRpcHandlers(rpcRegistry : RpcRegistry, target : ui.gameplay.networking.ActionHistoryClientHandlers)
{

    rpcRegistry.registerTyped(
        method = "ui.geopoliticsUpdate",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.GeopoliticsUpdateData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleGeopoliticsUpdate(ctx, payload)
        null
    }

    rpcRegistry.registerTyped(
        method = "ui.turnComplete",
        direction = RpcDirection.CLIENT,
        serializer = structs.GameHistory.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleTurnComplete(ctx, payload)
        null
    }
}

internal class ActionHistoryClientHandlersRpcHandlersRegistrationProvider(private val target : ui.gameplay.networking.ActionHistoryClientHandlers) : RpcRegistrationProvider
{
    override fun register(rpcRegistry : RpcRegistry)
    {
        registerActionHistoryClientHandlersRpcHandlers(rpcRegistry, target)
    }
}

internal val _actionHistoryClientHandlersRpcHandlersProvider = ActionHistoryClientHandlersRpcHandlersRegistrationProvider(ui.gameplay.networking.ActionHistoryClientHandlers).also {
    RpcRegistrationCollector.registerProvider(it)
}
